import SimpleCheckout from "@/pages/simple/SimpleCheckout";

/** Checkout for one shop: there is no screen of ours — Stripe opens at once (Phase 6 / 7.7). */
export default function Checkout() {
    return <SimpleCheckout />;
}
